import React from "react";

interface MenuSearchProps {
  className?: string;
}

const MenuSearch: React.FC<MenuSearchProps> = ({ className }) => (
  <div className={`flex items-center space-x-2 ${className || ""}`}>
    <button className="fill-gray-400 p-2" aria-label="Rechercher">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 54.72 54.7"
        className="h-5 w-5"
      >
        <path
          id="magnifyingGlass"
          d="m54.67,48.38c.16.74-.08,1.44-.73,2.09l-3.26,3.26c-.65.65-1.43.98-2.33.98s-1.68-.33-2.33-.98l-13.13-13.13c-1.59.9-3.29,1.62-5.1,2.14-1.81.52-3.71.79-5.7.79-2.97,0-5.77-.6-8.41-1.79-2.68-1.19-5.03-2.8-7.05-4.83-2.03-2.03-3.64-4.38-4.83-7.05-1.19-2.68-1.79-5.48-1.79-8.41s.56-5.75,1.68-8.36c1.12-2.6,2.65-4.87,4.59-6.81s4.21-3.46,6.81-4.59c2.6-1.12,5.39-1.68,8.36-1.68s5.79.6,8.47,1.79c2.64,1.19,4.97,2.79,7,4.8,2.03,2.01,3.64,4.35,4.83,7.03,1.19,2.68,1.79,5.5,1.79,8.47,0,2.03-.27,3.98-.81,5.86-.54,1.88-1.3,3.64-2.28,5.26l13.08,13.08c.61.65,1,1.35,1.17,2.09ZM6.62,21.44c0,2.03.42,3.98,1.25,5.86.87,1.88,2.01,3.53,3.42,4.94s3.06,2.55,4.94,3.42c1.88.83,3.83,1.25,5.86,1.25s4-.38,5.81-1.14c1.77-.8,3.33-1.86,4.67-3.2,1.34-1.34,2.41-2.91,3.2-4.72.76-1.81,1.14-3.73,1.14-5.75s-.42-4.02-1.25-5.86c-.83-1.88-1.96-3.54-3.39-4.97-1.43-1.43-3.08-2.56-4.97-3.39-1.84-.87-3.8-1.3-5.86-1.3s-3.98.4-5.75,1.19c-1.81.76-3.38,1.82-4.72,3.17-1.34,1.36-2.41,2.92-3.2,4.69-.76,1.81-1.14,3.74-1.14,5.81Z"
        ></path>
      </svg>
    </button>
    <span className="text-gray-nav">|</span>
    <a
      href="#"
      className="flex items-center gap-1 fill-gray-400 p-2 text-gray-400"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className="h-5 w-5 fill-current"
      >
        <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
      </svg>
      <span className="hidden text-sm sm:inline">Bienvenue</span>
    </a>
  </div>
);

export default MenuSearch;
